import { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { useOnboarding } from "../OnboardingContext";
import { useOnboardingStep } from "../hooks/useOnboardingStep";
import { FriendInvitationContainer } from "../../friendInvitation/components/FriendInvitation/FriendInvitationContainer";

export function OnboardingInviteFriendPage() {
  const navigate = useNavigate();

  const { completeStep } = useOnboardingStep();

  const { program } = useOnboarding();

  const handleCompleteStep = () => {
    startTransition(() => {
      completeStep("invite");

      navigate("/congratulations");
    });
  };

  if (!program) return null;

  return (
    <FriendInvitationContainer program={program} onDone={handleCompleteStep} />
  );
}

export default OnboardingInviteFriendPage;
